import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {SiteState} from "@/interfaces/state/site";
import {Site} from "@/interfaces/entity/site";
import {
    createSite, deleteSite,
    listSite,
    singleSite,
    updateSite
} from "@/modules/sites/services";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {SiteParams} from "@/modules/sites/params";
import {RegionStore} from "@/modules/regions/store";
import {PostOfficeStore} from "@/modules/postoffices/store";
import {EmployeeStore} from "@/modules/employees/store";
import {ServiceFee} from "@/interfaces/entity";
import { union, cloneDeep } from 'lodash';

@Module({ dynamic: true, name: "site", store })
class SiteModule extends VuexModule implements SiteState {
    data: IdMapper<Site> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: SiteParams = new SiteParams();

    cachedDataSite: IdMapper<Site> = {};
    @Mutation
    private UPDATE_SITE_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private MAP_SITE(payload: any) {
        const idMapper: IdMapper<Site> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((site: Site, index: number) => {
            idMapper[site.id!] = {
                ...site,
                stt: index + 1,
                isDeleting: false,
                isSaving: false,
                editable: false
            } as any;
            RegionStore.addProvince(site.province);
            RegionStore.addDistrict(site.district);
            RegionStore.addWard(site.ward);
            PostOfficeStore.addPostOffice(site.receivePostOffice);
            PostOfficeStore.addPostOffice(site.deliveryPostOffice);
            EmployeeStore.addEmployee(site.receiveEmployee);
            EmployeeStore.addEmployee(site.deliveryEmployee);
            return site.id;
        });
        this.data = idMapper;
        this.cachedDataSite = cloneDeep(idMapper);
    }

    @Mutation
    private ADD_SITE(payload: Site) {
        if (!payload || this.ids.includes(payload.id) || this.data[payload.id]) return;
        this.ids = [ ...this.ids, payload.id ];
        this.data = { ...this.data, [payload.id]: {...payload, isDeleting: false} }
    }

    @Mutation
    private UPDATE_SITE(payload: Site) {
        console.log(payload);
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = {
            ...payload,
            stt: payload.stt,
            isDeleting: false,
            isSaving: false,
            editable: false
        }
    }

    @Mutation
    private DELETE_SITE(payload: Site) {
        if (!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.ids = this.ids.filter((id: number) => id !== payload.id);
        delete this.data[payload.id];
    }

    @Mutation
    private START_DELETE_SITE(id: number) {
        this.data[id].isDeleting = true;
    }

    @Mutation
    private END_DELETE_SITE(id: number) {
        this.data[id].isDeleting = false;
    }

    @Action({ rawError: true })
    public addSite(payload: Site) {
        this.ADD_SITE(payload);
    }

    @Action({ rawError: true })
    public async createSite(form: any) {
        const { data } = await createSite(form);
        this.ADD_SITE(data.data);
    }

    @Action({ rawError: true })
    public async listSite(params: SiteParams = new SiteParams()) {
        const { data } = await listSite(params);
        this.MAP_SITE(data);
        return data.datas;
    }

    @Action({ rawError: true })
    public async singleSite(id: number) {
        const { data } = await singleSite(id);
        return data.data;
    }

    @Action({ rawError: true })
    public async updateSite(dataReq: any) {
        const { data } = await updateSite(dataReq.id, dataReq);
        this.UPDATE_SITE({ ...dataReq, ...data.data});
    }

    @Action({ rawError: true })
    public async deleteSite(id: number) {
        this.START_DELETE_SITE(id);
        const { data } = await deleteSite(id);
        this.END_DELETE_SITE(id);
        this.DELETE_SITE(data.data);
    }

    @Action({ rawError: true })
    public updateSiteParams(payload: any) {
        this.UPDATE_SITE_PARAMS(payload);
    }
}

export const SiteStore = getModule(SiteModule);